import { flow } from 'fp-ts/function';

import { Http } from '@catawiki/runtime-toolkit';

export const REQUEST_TIMEOUT_MS = 15000;

export const setServerHeader = (): ((
  config: Http.RequestConfig
) => Http.RequestConfig) => {
  if (!process.env.CW_API_HOST || !process.env.APP_CW_API_AUTH_TOKEN) {
    return flow(Http.setTimeoutMs(REQUEST_TIMEOUT_MS));
  }

  const withTimeout = Http.setTimeoutMs(REQUEST_TIMEOUT_MS);
  const withServerSideHeaders = Http.setServerHeaders({
    host: process.env.CW_API_HOST,
    app: process.env.APP_NAME || '',
    authToken: process.env.APP_CW_API_AUTH_TOKEN,
  });

  return (config) =>
    withServerSideHeaders(
      withTimeout({
        ...config,
        headers: {
          ...config.headers,
        },
      })
    );
};
